module.exports = __webpack_public_path__ + "static/media/firebaseLogo.6caacd1a.svg";